import React, {Component} from "react";
import SearchWrapper from "./layouts/SearchWrapper";
import Header from "./layouts/Header";
import BannerOne from "./layouts/BannerOne";
import Features from "./layouts/Features";
import AboutArea from "./layouts/AboutArea";
import HowCanHelpTwo from "./layouts/HowCanHelpTwo";
import ServiceArea from "./layouts/ServiceArea";
import WhyChooseUs from "./layouts/WhyChooseUs";
import RecentProducts from "./layouts/RecentProducts";
import Team from "./layouts/Team";
import Cta from "./layouts/Cta";
import Testimonials from "./layouts/Testimonials";
import BlogArea from "./layouts/BlogArea";
import Footer from "./layouts/Footer";

class HomeOne extends Component {
    render() {
        return (
            <>
                <SearchWrapper />
                <Header />
                <BannerOne />
                <Features />
                <AboutArea design={'home_1'} />
                <HowCanHelpTwo />
                <ServiceArea background={true} />
                <WhyChooseUs />
                <RecentProducts />
                <Team />
                <Cta />
                <Testimonials design={'home_1'} />
                <BlogArea />
              {/*  <Brands />  */}
                <Footer />
            </>
        );
    }
}

export default HomeOne;